//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        mode: String,
        carnoArr: Array,
        visible: Boolean,
        current: Number
    },
    data () {
        return {
            carTxt: [{
                name: ['粤', '京', '冀', '沪', '津', '晋', '蒙', '辽'],
                size: 'big',
                type: 'province'
            }, {
                name: ['苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂'],
                size: 'big',
                type: 'province'
            }, {
                name: ['琼', '渝', '川', '贵', '云', '藏', '陕', '甘'],
                size: 'big',
                type: 'province'
            }, {
                name: ['吉', '黑', '湘', '桂', '青', '宁', '新', 'delete'],
                size: 'big',
                type: 'province'
            }],
            numAlphaText: [{
                name: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
                size: 'normal',
                type: 'number'
            }, {
                name: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
                size: 'normal',
                type: 'alpha'
            }, {
                name: ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
                size: 'normal',
                type: 'alpha'
            }, {
                name: ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'delete'],
                size: 'normal',
                type: 'alpha'
            }, {
                name: ['港', '澳', '学', '领', '警'],
                size: 'normal',
                type: 'alpha'
            }],
            phoneText: [{
                name: ['1', '2', '3']
            },{
                name: ['4', '5', '6']
            },{
                name: ['7', '8', '9']
            },{
                name: ['&nbsp;', '0', 'delete']
            }]
        }
    },
    methods: {
        onClickKey (key, type) {
            this.$emit('onChange', key)
        },
        clear () {
            this.$emit('onClear')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/carNo-input/carNo-input-keyboard.vue